import { Translate, useTranslation } from "@privacy/translations";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { useMutation } from "@tanstack/react-query";
import { updateDpiaResponsibleMutationOptions } from "../../api/dpia";
import * as FormDialog from "../../shared/FormDialog";

type DpiaResponsibleWarningDialogProps = {
  dpia: { id: string; name: string };
  responsible: { id: string; name: string };
  onClose: () => void;
};

export const DpiaResponsibleWarningDialog = ({ dpia, responsible, onClose }: DpiaResponsibleWarningDialogProps) => {
  const { t } = useTranslation();
  const updateResponsibleMutation = useMutation(updateDpiaResponsibleMutationOptions());

  return (
    <FormDialog.Dialog isOpen={true}>
      <FormDialog.Title>{t("DpiaDrawer.Dialog.Responsible.Header")}</FormDialog.Title>

      <FormDialog.Form
        onSubmit={() =>
          updateResponsibleMutation.mutate({ dpiaId: dpia.id, userId: responsible.id }, { onSuccess: onClose })
        }
      >
        <FormDialog.Content>
          <FormDialog.FormError isError={updateResponsibleMutation.isError} />
          <Typography variant="body2">
            <Translate
              translationKey="DpiaDrawer.Dialog.Responsible.Message"
              values={{
                userName: (
                  <Box component="span" sx={{ fontWeight: "bold" }}>
                    {responsible.name}
                  </Box>
                ),
                dpiaName: (
                  <Box component="span" sx={{ fontWeight: "bold" }}>
                    {dpia.name}
                  </Box>
                ),
              }}
            />
          </Typography>
          <Typography variant="body2">{t("DpiaDrawer.Dialog.Responsible.RemainsCollaborator")}</Typography>
        </FormDialog.Content>
        <FormDialog.ActionButtons>
          <FormDialog.CancelButton onClick={onClose} />
          <FormDialog.SubmitButton isSubmitting={updateResponsibleMutation.isPending}>
            {t("DpiaDrawer.Dialog.Responsible.Button")}
          </FormDialog.SubmitButton>
        </FormDialog.ActionButtons>
      </FormDialog.Form>
    </FormDialog.Dialog>
  );
};
